module.exports = __webpack_public_path__ + "img/bg_image_1.ef68c49e.png";